import React from "react";
import { IoReloadCircleOutline } from "react-icons/io5";

import "react-circular-progressbar/dist/styles.css";

import { useSelector } from "react-redux";


export default function WalletDateFilter(props) {
  let ruppysymble = "\u20B9";
  const { transactionStatuswithAmount, sumOfallSatus, statusDate, setStatusDateHandler, reloadTxn, statusFilterHandler, permission } = props;
  const roles = useSelector(state => state.authReducer?.auth?.roles);
  return (
   
    

      <div className="className='col-12 col-md-6" >
          {/* <span class="badge badge-pill bg-danger mr-1"> */}
         
          <div className="status-dates"  >
          <div
                    // style={{ margin: 10 }}
                    class="form-floating float-left"
                    id="select-status-dates"
                  >
                    <input
                      type="date"
                      class="form-control"
                      id="from"
                      placeholder="From Date"
                      onChange={(e)=>setStatusDateHandler(e.target.value)}
                      value={statusDate}
                     
                    />
                    <label style={{ padding: "1rem 1.75rem" }} for="from">
                     Selected Date
                    </label>
          </div>
         
          
          </div>
         
          <IoReloadCircleOutline size={45} style={{cursor:'pointer', float:'right'}} onClick={reloadTxn}  />
        </div>
       
   
  );
}
